export default axiosInstance => {
  async function query({ patientNo }) {
    return (
      await axiosInstance({
        method: "get",
        url: "/pad/visit",
        params: { patientNo }
      })
    ).data;
  }

  return {
    query
  };
};
